<template>
  <gl-page icon-name="gr-farm" title="Search...">
    <div class="contentMain">
      <gl-loader />
    </div>
  </gl-page>
</template>

<script>
import { getBlock, getBlockList } from '@/services/api'
import GlPage from '@gl/GlPage'
import GlLoader from '@gl/GlLoader'

export default {
  name: 'BlocksSearch',
  components: { GlLoader, GlPage },
  mounted() {
    this.searchBlock()
  },
  methods: {
    async searchBlock() {
      const time = +new Date('' + this.$route?.params?.time)

      let blockStart = await this.getBlock(0) // { time: 1519862400000, height: 0 }
      let blockEnd = await this.getBlockLast()

      if (time < blockStart.time) {
        this.redirectTo(0)
        return
      }
      if (blockEnd.time < time) {
        this.redirectTo(blockEnd.height)
        return
      }

      let block = await this.getBlock(Math.floor(blockEnd.height / 2))
      while (blockEnd.height - blockStart.height > 2) {
        if (block.time < time) blockStart = block
        else blockEnd = block
        block = await this.getBlock(
          Math.floor(blockStart.height + (blockEnd.height - blockStart.height) / 2)
        )
      }
      await this.$router.push({ name: 'Blocks', params: { id: blockStart.height } })
    },
    async getBlock(id) {
      const { data } = await getBlock(id, true)
      if (data.state === 'success') {
        return data.data
      } else {
        throw new Error()
      }
    },
    async getBlockLast() {
      const { data } = await getBlockList(1)
      if (data.state === 'success' && data.data.length) {
        return data.data[0]
      } else {
        throw new Error()
      }
    },
    redirectTo(id) {
      this.$router.push({ name: 'Blocks', params: { id } })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/table';
</style>
